import styled from "styled-components";
import { SWReactTableWrapperBox } from "app/components/React/Table/SWReactTableGhostLoader";
import { SWReactTableWrapperFooter } from "app/components/React/Table/SWReactTableWrapper";
import { colorsPalettes, rgba } from "@similarweb/styles";

export const PaidSearchContainer = styled.div`
    ${SWReactTableWrapperBox} {
        box-shadow: none;
    }
    ${SWReactTableWrapperFooter} {
        box-shadow: 0 3px 6px 0 ${rgba(colorsPalettes.midnight[600], 0.08)};
    }
`;
